import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import FeaturedBot from "../components/site/FeaturedBot";
import PlayGame from "../components/site/PlayGame";
import Services from "../components/site/Services";
import WhyChoose from "../components/site/WhyChoose";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import ParticleBackground from "../components/site/ParticleBackground";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white overflow-hidden">
      <ParticleBackground />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <About />
        <FeaturedBot />
        <PlayGame />
        <Services />
        <WhyChoose />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
